const styles = {
  container: 'fixed top-0 left-0 right-0 w-full py-4 lg:py-8 z-50 bg-white',
  content:
    'flex flex-row items-center justify-between px-8 lg:px-0 bg-white gap-x-8',

  head: 'col-span-3 flex flex-row items-center',
  body: 'col-span-5 grow flex flex-row items-center justify-center',
  foot: 'col-span-3 flex flex-row items-center justify-end gap-x-4 lg:gap-x-6',

  list: 'flex-row gap-x-4 lg:gap-x-6 items-center',
  item: ' text-sm',
  separator: 'text-gray-200',
  highlight: 'text-[#29AAC7] font-semibold',

  link: '!text-base hover:text-red-500 duration-300 hover:!bg-none font-normal pr-4 !font-semibold',
};

export default styles;
